import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DESCRIPTION_SPACE, shortenValue } from './model/filtersDescription';

/** Пропсы значений части описания отбора */
type Props = {
  /** Показанные значения части одной строкой */
  text: string;
  /** Сколько значений свёрнуто в счётчик; `0` — показаны все */
  foldedCount: number;
  /** Предел длины текста в знаках; `null` — предела нет, текст показан целиком */
  limitChars: number | null;
};

/**
 * Значения части описания: сам текст и счётчик свёрнутых значений. Предел длины ложится только
 * на текст — счётчик от него не зависит и показан целиком.
 */
export const FiltersDescriptionValues: FC<Props> = ({ text, foldedCount, limitChars }) => {
  const { t } = useTranslation(['dialogs']);

  return (
    <>
      <span className="shrink-0">{shortenValue(text, limitChars)}</span>
      {foldedCount > 0 ? (
        <span className="shrink-0">
          {DESCRIPTION_SPACE}
          {t('dialogs:dialogListSection.filtersDescription.foldedCount', { count: foldedCount })}
        </span>
      ) : null}
    </>
  );
};
